<script>
    export let size="md";
</script>

<div class="h-{size}"></div>